import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { Layout } from "@kursk/components/Layout/Layout";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import styles from './TouristRoutes.module.scss';
import { Filters } from "@kursk/components/ui/Filters/Filters";
import { touristsRoutesSlice } from "@common/redux/slices/entities.slice";
import { touristRoutesSlice as touristsRoutesSliceDuration } from "@common/redux/slices/touristroutes.slice";
import { RoutesGrid } from "./RoutesGrid/RoutesGrid";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { regionContent } from "@kursk/content/regionContent";
import { HeroBlock } from "@kursk/components/ui/HeroBlock/HeroBlock";
import { picksSlice } from "@common/redux/slices/picks";
import React from "react";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";

const transportationItems = [
  {
    name: "Пешком",
    value: "walk",
  },
  {
    name: "На автомобиле",
    value: "auto",
  },
]

export const TouristRoutes = () => {
  const { total, meta, filters } = useSelectSlice(touristsRoutesSlice);
  const { rangeValues } = useSelectSlice(touristsRoutesSliceDuration)
  const { listEvents, listOverviews } = useSelectSlice(recommendationSlice);
  const { bannersInCatalogs } = useSelectSlice(picksSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);

  return (
    <Layout showSubscribePopup={false}>
      <SeoMetaTitles
        page="routes"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags, regionContent.entitiesNames.touristroutes.plural)}
      />
      <HeroBlock banners={bannersInCatalogs} page="routes"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            tags={meta.tags}
            selectedTags={selectedTags}
            title={regionContent.entitiesNames.touristroutes.plural}
            dashTitle={`Найдено ${regionContent.entitiesNames.touristroutes.pluralGenitive}`}
            total={total}
          />
        </div>
        <div className={styles.filters}>
          <Filters
            entityType={'touristroutes'}
            meta={meta}
            filters={filters}
            withAudio
            withLocales
            withDuration
            withDurationOptions={{
              durationsRange: rangeValues,
              dropDownTitle: 'Длительность (минуты)'
            }}
            withTransportation
            withTransportationOptions={{
              items: transportationItems,
              filterField: 'routeTypes',
            }}
          />
        </div>
        <div className={styles.items}>
          <RoutesGrid/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType='events'
            data={listEvents}
            title={'Рекомендуем посетить'}
            goTo={'/events'}
            goToTitle={'все события'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="overviews"
            data={listOverviews}
            title={'Рекомендуем почитать'}
            goTo={'/overviews'}
            goToTitle={'все обзоры'}/>
        </div>
        <div className={styles.recommendationSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
